import {
  FormControlConfig,
  IFormControlConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoDropdownConfig<T> extends IFormControlConfig {
  type?: 'dropdown';
  inputIcon?: string;
  inputStyleClass?: string;
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  appendTo?: any;
  group?: boolean;
  virtualScrollSize?: number;
  virtualScroll?: boolean;
}

export class EoDropdownConfig<T>
  extends FormControlConfig
  implements IEoDropdownConfig<T>
{
  override type?: 'dropdown';
  inputIcon?: string;
  inputStyleClass?: string;
  optionLabel?: string;
  optionValue?: string;
  options?: T[];
  dropdownStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  filter?: boolean;
  filterBy?: string;
  filterFields?: any[];
  filterPlaceholder?: string;
  appendTo?: any;
  group?: boolean;
  virtualScrollSize?: number;
  virtualScroll?: boolean;

  constructor();
  constructor(obj: IEoDropdownConfig<T>);
  constructor(obj?: IEoDropdownConfig<T>) {
    super(obj as IFormControlConfig);
    this.type = 'dropdown';
    this.inputIcon = obj?.inputIcon;
    this.inputStyleClass = obj?.inputStyleClass;
    this.optionLabel = obj?.optionLabel;
    this.optionValue = obj?.optionValue;
    this.options = obj?.options;
    this.dropdownStyleClass = obj?.dropdownStyleClass;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.showClear = obj?.showClear;
    this.filter = obj?.filter;
    this.filterBy = obj?.filterBy;
    this.filterFields = obj?.filterFields;
    this.filterPlaceholder = obj?.filterPlaceholder;
    this.appendTo = obj?.appendTo;
    this.group = obj?.group;
    this.virtualScrollSize = obj?.virtualScrollSize;
    this.virtualScroll = obj?.virtualScroll;
  }
}
